/* eslint-disable bsky-internal/avoid-unwrapped-text */
import {type ReactNode} from 'react'

import {useIsMobileWeb} from '#/alf'
import {Button, ButtonText} from '#/components/Button'
import {useSemanticTokens} from '#/wsocial/service/design-system'
import {IllustrationArea, MobileTopNav, PageShell} from './primitives'

export interface InfoSlideProps {
  title: ReactNode
  body: ReactNode
  illustration: ReactNode
  onBack?: () => void
  onSkip?: () => void
  skipLabel?: ReactNode
  onNext: () => void
  nextLabel?: ReactNode
}

export function InfoSlide({
  title,
  body,
  illustration,
  onBack,
  onSkip,
  skipLabel,
  onNext,
  nextLabel,
}: InfoSlideProps) {
  const isMobileWeb = useIsMobileWeb()
  const tokens = useSemanticTokens()

  return (
    <PageShell>
      {isMobileWeb && onBack && <MobileTopNav onBack={onBack} />}
      <IllustrationArea>{illustration}</IllustrationArea>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          padding: '24px 16px',
          textAlign: 'center',
        }}>
        <h1
          style={{
            fontSize: 30,
            fontWeight: 700,
            lineHeight: '35px',
            color: '#fff',
            margin: 0,
          }}>
          {title}
        </h1>
        <p
          style={{
            fontSize: 15,
            fontWeight: 400,
            lineHeight: '23px',
            color: tokens.onboarding.textMedium,
            margin: 0,
          }}>
          {body}
        </p>
      </div>

      {isMobileWeb ? (
        <div
          style={{
            padding: '16px 16px',
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}>
          {onSkip && (
            <Button
              label="Skip"
              color="primary"
              size="large"
              testID="skipBtn"
              onPress={onSkip}
              style={{alignSelf: 'stretch'}}>
              <ButtonText>{skipLabel ?? 'Skip'}</ButtonText>
            </Button>
          )}
          <Button
            label="Next"
            color="primary"
            size="large"
            testID="nextBtn"
            onPress={onNext}
            style={{alignSelf: 'stretch'}}>
            <ButtonText>{nextLabel ?? 'Next'}</ButtonText>
          </Button>
        </div>
      ) : (
        <div
          style={{
            padding: '16px 16px',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 10,
          }}>
          <Button
            label="Next"
            color="primary"
            size="large"
            testID="nextBtn"
            onPress={onNext}>
            <ButtonText>{nextLabel ?? 'Next'}</ButtonText>
          </Button>
          {onSkip && (
            <Button
              label="Skip"
              color="primary"
              size="large"
              testID="skipBtn"
              onPress={onSkip}>
              <ButtonText>{skipLabel ?? 'Skip'}</ButtonText>
            </Button>
          )}
        </div>
      )}
    </PageShell>
  )
}
